import React from "react";
import { KTSVG } from "../../../_metronic/helpers";
import { usePageData } from "src/_metronic/layout/core";
import { useIntl } from "react-intl";

export type SimpleEntityGridExternalFilterProps = {
    onChange: (pageTitle?: string) => void;
};

export const SimpleEntityGridRest: React.FC<SimpleEntityGridExternalFilterProps> = ({
    onChange,
}) => {
    const { pageTitle } = usePageData();
    const { formatMessage } = useIntl();
    return (
        <button
            className="btn btn-sm btn-outline-primary"
            title={formatMessage({ id: "common.action.reset" })}
            onClick={() => onChange(pageTitle)}
        >
            <KTSVG path="/media/icons/duotune/arrows/arr029.svg" className="svg-icon svg-icon-2" />
        </button>
    );
};
